var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDcouments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#5BC5F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1135_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9922 36.4191H13.252V8.45674H32.807L35.7576 11.4104V29.1476",
    stroke: "white",
    strokeWidth: 0.913503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8867 15.7678H33.6391",
    stroke: "white",
    strokeWidth: 0.913503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8867 20.043H33.6391",
    stroke: "white",
    strokeWidth: 0.913503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8867 24.3182H33.6391",
    stroke: "white",
    strokeWidth: 0.913503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8867 28.5904H27.7531",
    stroke: "white",
    strokeWidth: 0.913503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7573 11.4104L32.8066 8.45674V11.4104H35.7573Z",
    stroke: "white",
    strokeWidth: 0.913503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2809 15.3841H8.51172V32.9904H10.2809V15.3841Z",
    stroke: "white",
    strokeWidth: 0.913503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2809 17.674H8.51172V19.4583H10.2809V17.674Z",
    stroke: "white",
    strokeWidth: 0.913503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50781 32.9904H10.277L9.39391 36.4191L8.50781 32.9904Z",
    stroke: "white",
    strokeWidth: 0.913503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2773 19.4584H11.4344V26.2305",
    stroke: "white",
    strokeWidth: 0.913503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7584 39.5432C38.6291 39.5432 40.9562 37.2161 40.9562 34.3454C40.9562 31.4747 38.6291 29.1476 35.7584 29.1476C32.8877 29.1476 30.5605 31.4747 30.5605 34.3454C30.5605 37.2161 32.8877 39.5432 35.7584 39.5432Z",
    stroke: "white",
    strokeWidth: 0.913503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0332 34.3454L35.7871 36.4191L38.08 32.2961",
    stroke: "white",
    strokeWidth: 0.913503,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1135_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.3611,
    height: 32,
    fill: "white",
    transform: "translate(8.05078 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcouments);
export default __webpack_public_path__ + "static/media/Dcouments.b1c96f2f3423a289fb7ad3377dba9ab0.svg";
export { ForwardRef as ReactComponent };